import React, {useState} from "react";
import {HelpHttp} from "helpers/HelpHttp";

let lastUser = localStorage.getItem('lastUser') || '';
const initialForm = {email: lastUser, password: ''};

const Login = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [form, setForm] = useState(initialForm);
    const handleChange = (e) => {
        setForm({...form, [e.target.name]: e.target.value});
    }

    let api = HelpHttp();
    let url = `${process.env.REACT_APP_API}/auth/signIn`

    const handleLogin = (e) => {
        e.preventDefault();
        login(form);
        setError(null);
    }
    const login = (data) => {

        setLoading(true);
        let options = {body: data, headers: {'content-type': 'application/json'}};
        api.post(url, options).then(res => {
            setLoading(false);
            if (res.err) {
                // setRequestError(res);
            } else {
                if (res.success) {
                    console.log(res);
                    //localStorage.setItem('token', JSON.stringify(res.token));
                    localStorage.setItem('token', res.token);
                    localStorage.setItem('lastUser', data.email);

                    window.location.href = '/';
                    // history.push('/');
                } else {
                    setError(res.message);
                    form.password = null;
                    setForm({...form, password: ''});
                }
            }
        });
    }

    return (
        <div className="container">
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh'
            }}>
                <form>
                    <div className="row">
                        <div className="col-sm-6 col-xs-12">
                            <img src="/img_login.svg" alt="" style={{width: '100%'}}
                                 className="d-inline-block align-text-top"/>
                        </div>
                        <div className="offset-sm-2 col-md-4 col-xs-12 ">
                            <h2 className="text-center mb-4" style={{color: '#009CDD'}}>ADMINISTRACIÓN DE SERVICIOS</h2>
                            <div className="mb-4 text-center">
                                <img src="/wd.png" alt="" style={{width: '70%'}}/>
                            </div>
                            {error && <div className="alert alert-danger" role="alert">{error}</div>}

                            <label htmlFor="email" className="form-label">Correo Electrónico</label>
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <div className="input-group-text">@</div>
                                </div>
                                <input type="text" className="form-control" id="email" name="email" autoComplete="off"
                                       value={form.email} onChange={handleChange} placeholder="Correo Electrónico"/>
                            </div>
                            <label htmlFor="password" className="form-label">Contraseña</label>
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <div className="input-group-text"><i className="bi bi-lock"/></div>
                                </div>
                                <input type="password" className="form-control" id="password" name="password"
                                       autoComplete="off" placeholder="Contraseña"
                                       value={form.password} onChange={handleChange}/>
                            </div>

                            {!loading &&
                            <button type="submit" className="btn btn-primary form-control" onClick={handleLogin}>
                                <i className="bi bi-box-arrow-in-right"/> Iniciar Sesión
                            </button>}
                            {loading && <button className="btn btn-primary form-control" type="button" disabled>
                                <span className="spinner-border spinner-border-sm" role="status"
                                      aria-hidden="true"></span>
                                &nbsp; Iniciando Sesión...
                            </button>}
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}
export default Login;
